<template>
  <section class="glass-panel flex flex-col gap-4 rounded-xl p-5">
    <header v-if="title || description || $slots.actions" class="flex flex-col gap-1">
      <div class="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
        <h2 v-if="title" class="m-0 min-w-0 text-base font-semibold text-foreground">
          {{ title }}
          <span v-if="required" class="text-destructive">*</span>
        </h2>
        <div v-if="$slots.actions" class="ml-auto flex shrink-0 items-center gap-3 whitespace-nowrap">
          <slot name="actions" />
        </div>
      </div>
      <!-- Translated strings may carry inline markup (<strong>, links). -->
      <p v-if="description" class="m-0 text-sm text-muted-foreground" v-html="description" />
    </header>

    <slot />
  </section>
</template>

<script>
/**
 * A titled block of a settings / form page.
 */
export default {
  name: 'FormSection',
  props: {
    title: {
      type: String,
      required: false,
      default: () => '',
    },
    description: {
      type: String,
      required: false,
      default: () => '',
    },
    required: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  },
};
</script>
